<template>
  <Page title="Lehrpersonen" color="error">
    <template slot="extension">
      <v-tabs align-with-title background-color="error darken-1">
        <v-tab :to="{ name: 'TeacherList' }">Liste</v-tab>
        <v-tab :to="{ name: 'TeacherDepartments' }">Fachschaften</v-tab>
        <v-tab :to="{ name: 'TeacherFlipper' }">Flipper</v-tab>
      </v-tabs>
    </template>
    <v-toolbar flat>
      <DivisionFilterSingle
        class="mb-3"
        v-model="filterDivision"
        :disabled="$router.currentRoute.name == 'TeacherDepartments'"
      />

      <DepartmentFilter
        hideDetails
        class="mb-3 ml-3"
        v-model="filterDepartment"
        :disabled="
          filterNew && $router.currentRoute.name !== 'TeacherDepartments'
        "
      />

      <v-spacer></v-spacer>
      <v-switch
        v-model="filterNew"
        inset
        label="Neue"
        class="mr-4"
        :disabled="$router.currentRoute.name == 'TeacherDepartments'"
      />
      <v-switch v-model="filterStvs" inset label="Stvs" />
    </v-toolbar>
    <router-view
      @department="(id) => (filterDepartment = { id: id })"
      :filterDivision="filterDivision"
      :filterDepartment="filterDepartment ? filterDepartment.id : 0"
      :filterStvs="filterStvs"
      :filterNew="filterNew"
    ></router-view>
  </Page>
</template>

<script>
import { defineComponent } from "vue";
import DepartmentFilter from "@/components/DepartmentFilter.vue";
import DivisionFilterSingle from "@/components/DivisionFilterSingle.vue";

export default defineComponent({
  name: "Teachers",
  components: { DepartmentFilter, DivisionFilterSingle },
  data() {
    return {
      filterDepartment: {},
      filterDivision: 0,
      filterStvs: false,
      filterNew: false,
    };
  },
});
</script>
